<template>
  <div class="modal" ref="modal" :class="{ 'is-open': isOpen }" v-on:keyup.esc="close">
    <div class="modal__body">
      <div class="o-grid o-grid_full_h">
        <div class="o-grid__cell o-wrapper u-vam">
          <span v-on:focus="forwardFocus(focusables[focusables.length - 1])" class="focus-forwarder" tabindex="0"></span>

          <button ref="modalclosebutton" v-on:click="close" class="modal__close" :title="$t('close')">
            <icon name="close"></icon>
          </button>

          <slot></slot>

          <span v-on:focus="forwardFocus(focusables[0])" class="focus-forwarder" tabindex="0"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      isOpen: {
        type: Boolean,
        default: false
      },

      // Focusable elements to cycle through.
      focusables: {
        type: Array,
        default: []
      }
    },

    methods: {
      close (ev) {
        ev.stopPropagation()
        this.$emit('closemodal')
      },

      forwardFocus (focusable) {
        focusable.focus()
      }
    },

    watch: {
      isOpen () {
        if (this.isOpen) {
          document.body.classList.add('is-locked')
          // Time it take to show the modal (css animation time).
          setTimeout(() =>
            // The close button is the first focusable element.
            (this.focusables[1] || this.$refs.modalclosebutton).focus(), 500
          )
        } else {
          document.body.classList.remove('is-locked')
        }
      }
    },

    mounted () {
      this.focusables =
        this.$el.querySelectorAll(
          'button, [href], input, select, textarea, \
          [tabindex]:not([tabindex="-1"]):not(.focus-forwarder)'
        )
    }
  }
</script>

<style>
  .modal {
    position: fixed;
    z-index: 9;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(17,17,17, 0.9);
    opacity: 0;
    visibility: hidden;
    transition: opacity 500ms, visibility 500ms;
  }

  .modal.is-open {
    opacity: 1;
    visibility: visible;
  }

  .modal__body {
    overflow: auto;
    height: 100%;
    width: 100%;
    padding-top: 4em;
    padding-bottom: 4em;
    text-align: center;
  }

  .modal__close {
    position: absolute;
    top: 2em;
    right: 2em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue